<template src='./index.html'>
  
</template>
<script>
import { getdata } from './data'
export default{
  props:{
    overlength:{
      type:Number,
      default:''
    }
  },
  data(){
    return{
      //表格
      size:'',
      headData:getdata().headData,
      tableData:[{
        tes1:'21983739281098',
        tes2:'1',
        tes3:'1',
        tes4:'1',
        tes5:'1',
        tes6:'2023-01-02 12:21:12',
        tes7:'21123.09',
        tes8:'乌鲁木齐泛亚景观设计有限公司',
        tes9:'Apsc2304261655901',
        tes10:'2023-01-02 12:21:12',
        tes11:'2023-01-02 12:21:12',
        tes12:'1',
        tes12:'错误：错误详情',
      }],
      pagination:getdata().pagination,
      tablekey:0,
      shaidiag:false,
      outlist:[],
    }
  },
  components:{

  },
  created(){

  },
  methods:{
    currentChange(e) {
      this.pagination.pageNum = e;
    },
    sizechange(e) {
      this.pagination.pageSize = e;
    },
    //表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
    confirmfilter(e) {
			localStorage.setItem('InScheduledTasksoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('InScheduledTasksheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
		}
  }
}
</script>
<style scoped>
@import url('./index.less');
</style>